import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { UserContext, UserContextProvider } from './components/UserContext';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
//import stylesheets
import 'bootstrap/dist/css/bootstrap.min.css';

const themes={
  //dark:'https://unpkg.com/@progress/kendo-theme-default@10.0.0/dist/default-main-dark.css',
  //light:'https://unpkg.com/@progress/kendo-theme-default@10.0.0/dist/default-main.css'
  dark:'https://unpkg.com/@progress/kendo-theme-bootstrap@11.0.2/dist/bootstrap-main-dark.css',
  light:'https://unpkg.com/@progress/kendo-theme-bootstrap@11.02/dist/bootstrap-main.css'
  
}


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  //<React.StrictMode>
  <ThemeSwitcherProvider
    themeMap={themes}
    defaultTheme='light'
    insertionPoint="styles-insertion-point"
  >
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </ThemeSwitcherProvider> 
  //</React.StrictMode>
);